import { Box, ButtonGroup, IconButton, TextField, Tooltip, Zoom } from "@material-ui/core";
import { Create, ThumbDown, ThumbUp, AddToQueue, Backup, Cancel, Assignment } from "@material-ui/icons";
import React, { useEffect } from "react";
import { Confirm, useNotify, useRefresh } from "react-admin";
import { DetailButton } from "../../../../../Components/DetailButton";
import { useAppDataProvider } from "../../../../../dataprovider";
import { PbhRequestStatus } from "../../../../../Enums/PbhRequestStatus";
import { RemarkTypes } from "../../../../../Enums/RemarkTypes";
import PbhRequestOrderReserveForm from "../ReserveForm/PbhRequestOrderReserveForm";
import PbhRequestOrderFileUpload from "../Uploads/PbhRequestOrderFileUpload";
import { PbhRequestFileType } from "../../../../../../src/Enums/PbhRequestFileType";
import ExperienceNoteType from "../../../../../Enums/ExperienceNoteType";
import DOMPurify from "dompurify";
import { useAuth } from "@airborne/react-admin";
import { ConfirmButton } from "../../../../../../src/Components/ConfirmButton";
import AdvancedXoPopup from "../../../../../../src/Components/AdvancedXoPopup/AdvancedXoPopup";
export const DataGridActionsButtons = props => {
  const [openAccept, setOpenAccept] = React.useState(false);
  const [openReject, setOpenReject] = React.useState(false);
  const [customerAndExperienceNotes, setCustomerAndExperienceNotes] = React.useState<any>(null);
  const [remark, setRemark] = React.useState("");
  const [remarkValidation, setRemarkValidation] = React.useState(false);
  const [reserveFormOpen, setReserveFormOpen] = React.useState(false);
  const [fileUploadOpen, setFileUploadOpen] = React.useState(false);
  const [advancedXoOpen, setAdvancedXoOpen] = React.useState(false);
  const refresh = useRefresh();
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();

  useEffect(() => {
    if (props?.tabValue == PbhRequestStatus.Open) {
      fetchNoteAndExperienceData();
    }
  }, [props?.record]);

  const fetchNoteAndExperienceData = async () => {
    try {
      const [experiencesData, notesData] = await Promise.all([
        dataProvider.getList("experiences", {
          pagination: { page: 1, perPage: 500 },
          sort: { field: "id", order: "DESC" },
          filter: {
            pn__eq: props?.record?.pn,
            noteType__eq: ExperienceNoteType.Info,
            customerId__eq: props?.record?.customerId,
            ...(user?.isCustomer ? { isShownCustomer__eq: true } : { isShownTt__eq: true }),
          },
        }),
        dataProvider.getList("PbhRequestRemarks", {
          pagination: { page: 1, perPage: 100 },
          sort: { field: "id", order: "ASC" },
          filter: {
            requestId__eq: props?.record?.id,
            remarkType__eq: RemarkTypes.CustomerFirstRemark,
            ...(user?.isCustomer ? { isCustomer__eq: true } : {}),
          },
        }),
      ]);

      const experienceTexts =
        experiencesData?.data?.map(exp => exp.remark).join(" ") || "No experience notes available.";
      const notesTexts = notesData?.data?.map(note => note.remark).join(" ") || "No customer notes available.";

      setCustomerAndExperienceNotes({ customerNotes: notesTexts, experienceNotes: experienceTexts });
    } catch (error) {
      console.error("Fetch Customer or Experience error:", error);
    }
  };
  const onClickRemark = () => {
    props.onEdit(props.record?.id, "/pbhrequestremarks/pbhrequestorders/", props.record);
  };
  const onClickDetail = () => {
    props.onEdit(props.record?.id);
  };
  const OnClickAccept = () => {
    let model = { ...props.record, ...{ requestStatus: getAcceptStatus() } };
    dataProvider.updatePbhRequestOrder(model).then(result => {
      props?.reloadTabs?.();
      refresh();
      notify(`Record updated`, "success", false, true);
      handleAcceptDialogClose();
    });
  };
  const OnClickReject = () => {
    props.record.requestStatus = getRejectStatus();

    if (props.tabValue == PbhRequestStatus.WaitingPoolScope || props.tabValue == PbhRequestStatus.Open) {
      updatePbhRequestWithRemark(props.record);
    } else if (props.tabValue == PbhRequestStatus.RejectionProposal) {
      updatePbhRequestWithSvcTtRejectionNote(props.record);
    } else {
      updatePbhRequest(props.record);
    }
  };
  const updatePbhRequestWithRemark = model => {
    if (!remark) {
      setRemarkValidation(true);
      return;
    }
    setRemarkValidation(false);
    const remarkModel = {
      requestId: model.id,
      statusCode: model.requestStatus,
      remark: remark,
      remarkTypeCode: RemarkTypes[RemarkTypes.PbhRejectNote],
      remarkType: RemarkTypes.PbhRejectNote,
    };

    dataProvider.createPbhRequestRemarks(remarkModel).then(result => {
      updatePbhRequest(model);
    });
  };
  const updatePbhRequest = model => {
    dataProvider.updatePbhRequestOrder(model).then(result => {
      props?.reloadTabs?.();
      refresh();
      notify(`Record updated`, "success", false, true);
      handleRejectDialogClose();
    });
  };
  const updatePbhRequestWithSvcTtRejectionNote = async model => {
    if (!remark) {
      setRemarkValidation(true);
      return;
    }
    setRemarkValidation(false);

    try {
      // Fetch the serviceable record for this request
      const serviceableResponse = await dataProvider.getList("pbhrequestserviceables", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "id", order: "DESC" },
        filter: { requestId__eq: model.id },
      });

      if (serviceableResponse?.data && serviceableResponse.data.length > 0) {
        const serviceableRecord = serviceableResponse.data[0];

        // Prepare the serviceable update model with the rejection note
        const serviceableUpdateModel = {
          ...serviceableRecord,
          TtRejectionNote: remark,
          updatedBy: user?.employeeId,
          updatedDate: new Date(),
        };

        // Update the serviceable record with the rejection note
        await dataProvider.putPbhRequestServiceable(serviceableUpdateModel).then(result => {
          updatePbhRequest(model);
        });
      }

      // Update the request status
      updatePbhRequest(model);
    } catch (error) {
      notify(`Error updating serviceable: ${error}`, "error", false, true);
      setRemarkValidation(false);
    }
  };
  const getAcceptStatus = () => {
    var status = 0;
    switch (props.tabValue) {
      case PbhRequestStatus.WaitingPoolScope:
        status = PbhRequestStatus.Open;
        break;
      case PbhRequestStatus.Open:
        status = props.record?.isLocalRepair === true ? PbhRequestStatus.LocalRepair : PbhRequestStatus.UnshippedSvc;
        break;
      case PbhRequestStatus.RejectionProposal:
        status = PbhRequestStatus.SvcRedelivery;
        break;
      default:
        break;
    }
    return status;
  };
  const getRejectStatus = () => {
    var status = 0;
    switch (props.tabValue) {
      case PbhRequestStatus.WaitingPoolScope:
        status = PbhRequestStatus.RejectedDueToPoolScope;
        break;
      case PbhRequestStatus.Open:
        status = PbhRequestStatus.Rejected;
        break;
      case PbhRequestStatus.RejectionProposal:
        status = PbhRequestStatus.PreviousStatus;
        break;
      default:
        break;
    }
    return status;
  };
  const CancelButton = props => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40, color: props?.disabled ? "" : "#C90C0F" }}
        size="medium"
        click={cancelOnClick(props?.record)}
        disabled={props.disabled}
      >
        <Tooltip TransitionComponent={Zoom} title="Cancel Request">
          <Cancel />
        </Tooltip>
      </ConfirmButton>
    );
  };
  const cancelOnClick = record => e => {
    dataProvider
      .getOne("pbhrequestorders/", { id: record.id })
      .then(response => {
        response.data.requestStatus = PbhRequestStatus.Cancelled;
        dataProvider
          .updatePbhRequestOrder(response.data)
          .then(result => {
            notify(`Record Updated`, "success", false, true);
          })
          .catch(error => notify(`${error}`, "error", false, true));
      })
      .finally(() => refresh());
  };

  const handleAcceptDialogClose = () => setOpenAccept(false);

  const handleAcceptDialogOpen = () => setOpenAccept(true);

  const handleRejectDialogClose = () => {
    setOpenReject(false);
  };

  const handleRejectDialogOpen = () => setOpenReject(true);

  const handleChangeRemark = e => setRemark(e.target.value);

  const handleReserveOpen = e => setReserveFormOpen(true);

  const handleFileUploadOpen = e => setFileUploadOpen(true);

  const handleAdvancedXoOpen = () => setAdvancedXoOpen(true);

  return (
    <>
      <Confirm
        isOpen={openAccept}
        title={`Accept`}
        content={
          <>
            <p>Are you sure you want to accept?</p>
            {props.record?.isPnRie === true && (
              <p style={{ color: "#e65c00", fontWeight: "bold" }}>
                This PN has an open RIE record. Do you want to continue?
              </p>
            )}
            {customerAndExperienceNotes != null && (
              <>
                <p style={{ wordWrap: "break-word", overflowWrap: "break-word" }}>
                  <b>Customer Notes:</b> {customerAndExperienceNotes?.customerNotes}
                </p>
                <p style={{ wordWrap: "break-word", overflowWrap: "break-word" }}>
                  <b>Experience Notes:</b>{" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(customerAndExperienceNotes?.experienceNotes ?? ""),
                    }}
                  />
                </p>
              </>
            )}
          </>
        }
        onConfirm={OnClickAccept}
        onClose={handleAcceptDialogClose}
      />
      {props.tabValue != PbhRequestStatus.WaitingPoolScope &&
        props.tabValue != PbhRequestStatus.Open &&
        props.tabValue != PbhRequestStatus.RejectionProposal && props.tabValue != PbhRequestStatus.Suspended  && (
          <Confirm
            isOpen={openReject}
            title={`Reject`}
            content={
              <>
                <p>Are you sure you want to reject?</p>
                {props.record?.isPnRie === true && (
                  <p style={{ color: "#e65c00", fontWeight: "bold" }}>
                    This PN has an open RIE record. Do you want to continue?
                  </p>
                )}
              </>
            }
            onConfirm={OnClickReject}
            onClose={handleRejectDialogClose}
          />
        )}
      {props.tabValue == PbhRequestStatus.RejectionProposal && (
        <Confirm
          isOpen={openReject}
          title={`Are you sure you want to reject?`}
          content={
            <>
              {props.record?.isPnRie === true && (
                <p style={{ color: "#e65c00", fontWeight: "bold" }}>
                  This PN has an open RIE record. Do you want to continue?
                </p>
              )}
              <TextField
                label="SvcTtRejectionNote"
                error={remarkValidation}
                required
                value={remark}
                multiline
                fullWidth
                maxRows={4}
                variant="outlined"
                onChange={handleChangeRemark}
              />
            </>
          }
          onConfirm={OnClickReject}
          onClose={handleRejectDialogClose}
        />
      )}
      {(props.tabValue == PbhRequestStatus.WaitingPoolScope || props.tabValue == PbhRequestStatus.Open ) && (
        <Confirm
          isOpen={openReject}
          title={`Are you sure you want to reject?`}
          content={
            <>
              {props.record?.isPnRie === true && (
                <p style={{ color: "#e65c00", fontWeight: "bold" }}>
                  This PN has an open RIE record. Do you want to continue?
                </p>
              )}
              {customerAndExperienceNotes != null && (
                <>
                  <p style={{ wordWrap: "break-word", overflowWrap: "break-word" }}>
                    <b>Customer Notes:</b> {customerAndExperienceNotes?.customerNotes}
                  </p>
                  <p style={{ wordWrap: "break-word", overflowWrap: "break-word" }}>
                    <b>Experience Notes:</b>{" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(customerAndExperienceNotes?.experienceNotes ?? ""),
                      }}
                    />
                  </p>
                </>
              )}
              <TextField
                label="Remark"
                error={remarkValidation}
                required
                value={remark}
                multiline
                fullWidth
                maxRows={4}
                variant="outlined"
                onChange={handleChangeRemark}
              />
            </>
          }
          onConfirm={OnClickReject}
          onClose={handleRejectDialogClose}
        />
      )}
      {(props.tabValue == PbhRequestStatus.UnshippedSvc || props.tabValue == PbhRequestStatus.Reserved) && (
        <PbhRequestOrderReserveForm
          callback={props.reloadTabs}
          handleClose={setReserveFormOpen}
          open={reserveFormOpen}
          requestId={props?.record?.id}
          refNo={props?.record?.refNo}
          tabValue={props.tabValue}
        />
      )}
      {props.tabValue == PbhRequestStatus.WaitingPoolScope && (
        <PbhRequestOrderFileUpload
          handleClose={setFileUploadOpen}
          open={fileUploadOpen}
          requestId={props?.record?.id}
          source="pbhrequestorderfilerelations"
          pbhRequestFileTypeGroup={PbhRequestFileType.None}
          pbhRequestFileType={PbhRequestFileType.WaitingPoolScopeList}
        />
      )}
      {(props.tabValue == PbhRequestStatus.UnshippedSvc || props.tabValue == PbhRequestStatus.Reserved || props.tabValue == PbhRequestStatus.Suspended) && (
        <AdvancedXoPopup
          open={advancedXoOpen}
          handleClose={setAdvancedXoOpen}
          record={props?.record}
          callback={props?.reloadTabs}
        />
      )}

      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          {props.tabValue !== PbhRequestStatus.UnshippedSvc &&
            props.tabValue !== PbhRequestStatus.Reserved &&
            props.tabValue !== PbhRequestStatus.ShippingProcess &&
            props.tabValue !== PbhRequestStatus.Suspended &&  (
              <>
                <IconButton {...props} style={{ width: 40, color: "#008000" }} onClick={handleAcceptDialogOpen}>
                  <Tooltip title="Accept">
                    <ThumbUp />
                  </Tooltip>
                </IconButton>
                <IconButton {...props} style={{ width: 40, color: "#FF0000" }} onClick={handleRejectDialogOpen}>
                  <Tooltip title="Reject">
                    <ThumbDown />
                  </Tooltip>
                </IconButton>
              </>
            )}

          {!user?.isCustomer && <CancelButton {...props} onClick={cancelOnClick} />}
          <DetailButton resource={"pbhrequestorders"} onClick={onClickDetail} onClickDisabled={true} />
          {new Date(props?.record?.requestedDeliveryDate) > new Date() &&
            (props.tabValue == PbhRequestStatus.UnshippedSvc || props.tabValue == PbhRequestStatus.Reserved) && (
              <IconButton style={{ width: 40 }} onClick={handleReserveOpen}>
                <Tooltip TransitionComponent={Zoom} title="Component Reserve Form">
                  <AddToQueue />
                </Tooltip>
              </IconButton>
            )}
          {(props.tabValue == PbhRequestStatus.UnshippedSvc || props.tabValue == PbhRequestStatus.Reserved || props.tabValue == PbhRequestStatus.Suspended) && (
            <IconButton style={{ width: 40, color: "#6366F1" }} onClick={handleAdvancedXoOpen}>
              <Tooltip TransitionComponent={Zoom} title="Advanced XO">
                <Assignment />
              </Tooltip>
            </IconButton>
          )}
          {props.tabValue == PbhRequestStatus.WaitingPoolScope && (
            <IconButton style={{ width: 40 }} onClick={handleFileUploadOpen}>
              <Tooltip TransitionComponent={Zoom} title="File Upload">
                <Backup />
              </Tooltip>
            </IconButton>
          )}
          {!user?.isCustomer && (
            <IconButton style={{ width: 40 }} onClick={onClickRemark}>
              <Tooltip TransitionComponent={Zoom} title="Add Note">
                <Create />
              </Tooltip>
            </IconButton>
          )}
        </ButtonGroup>
      </Box>
    </>
  );
};

export default DataGridActionsButtons;
